import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyType } from '@app/core/balance.service';
import { CryptoCurrencyOptions, CURRENCY_OPTIONS } from '@app/core/constants';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

@Pipe({ name: 'crypto' })
export class CryptoPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe, private decimalPipe: DecimalPipe) {}
  transform(
    value: number,
    currency: CurrencyType | string,
    display?: 'code' | 'symbol' | 'symbol-narrow',
    onlyNumber?: boolean,
    extraDecimals?: number | boolean
  ): string | null {
    const _currency = currency.toString().toLowerCase();
    if (CURRENCY_OPTIONS.hasOwnProperty(_currency)) {
      const options = CURRENCY_OPTIONS[_currency];
      if (options.isCrypto) {
        let displaySymbol = options.symbol;
        if (display === 'code') {
          displaySymbol = options.code;
        }

        const decimals = this.getDecimals(options.visibleDecimals, extraDecimals);

        const amount = this.decimalPipe.transform(this.floatAmount(value, decimals), `1.${decimals}-${decimals}`);

        if (onlyNumber) {
          return amount;
        }

        return `${amount} ${displaySymbol}`;
      }
      return this.currencyPipe.transform(value, options.code, display);
    }
    return this.currencyPipe.transform(value, String(currency).toUpperCase(), display);
  }

  private floatAmount(amount: number, decimals: number): number {
    return Number(amount.toFixedFloor(decimals));
  }

  private getDecimals(decimals: number, extra: boolean | number): number {
    switch (typeof extra) {
      case 'number':
        return decimals + Number(extra);
      case 'boolean':
        return decimals + (extra ? 2 : 0);
      default:
        return decimals;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/pipes/crypto.pipe.ts